import { WarrantyRegistrationSchema } from "@redotech/redo-model/warranty-registration";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const updateWarrantyRegistrationProduct = {
  name: "updateWarrantyRegistrationProduct" as const,
  input: z.object({ registrationId: zExt.objectId(), variantId: z.string() }),
  output: WarrantyRegistrationSchema,
};
